import styled from 'styled-components';

const Contenedor = styled.div`
button:focus {
  outline:none;
}
section.contenedor-factores {
  border: 1px solid #e2e2e2;
}
  .contenedor-autorizacion header h2 {
    color: #383838;
    font-size: 18px;
  }
  .contenedor-autorizacion header {
    padding: 15px 32px;
  }
  .formulario-login-coopeuch {
    max-width: 450px;
    margin: 0 auto;
    padding-bottom: 25px;
    padding: 15px;
  }

.contenedor-autorizacion .subtitulo-formulario {
    line-height: 16px;
    color: #333333;
    font-weight: 400;
    padding-bottom: 22px;
    padding-right: 41px;
  }

  .contenedor-medios-de-pago {
    max-height: ${props => props.loaderTercerFactorSolicitar ? '260px' : 'unset'};
  }
  
  .contenedor-medios-de-pago section:nth-child(2) {
    margin-top: 10px;
  }

  form.formulario-webpay-login input {
    border-radius: 7px;
  }
  form.formulario-webpay-login label {
    display: block;
    margin-top: 15px;
    color: #383638;
    font-weight: bold;
    position: relative;
  }

  .AccordionItem--title {
    font-size: 16px;
    color: #333333;
    font-weight: 400;
  }

  .autorizacion .CardBase {
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .AccordionItem .AccordionItem--header {
    border-radius: 0;
    padding: 8px 48px;
    padding-left: 32px;
    padding-right: 19px;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .InputCoordinateCard .InputCoordinateCard__input-group {
    padding-top: 10px;
    column-gap: 18px;
  }

  .AccordionItem {
    width: 100%;
    border-bottom: 1px solid #D4D4D4;
    box-shadow: 0 0 0px 0 rgb(0 0 0 / 11%);
  }


  .AccordionItem--content {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    padding-left: 31px;
    padding-right: 57px;
    padding-top: 0;
  }

  .contenedor-autorizacion {
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 14%);
    border-radius: 6px;
    margin-bottom: 26px;
  }

  .body-webpay-coopeuch .Button--primary {
    float: right;
    width: 43%;
    margin-bottom: 25px;
  }

  .ClockHelper__label {
    align-items: center;
  }

  .Input.Input--normal input {
    width: 94px;
    height: 48px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 6px;
  }

  ._2p8qe._1r-Fe {
    float: left;
    padding-left: 0;
  }
  i._3KDDD {
    margin-right: 2px;
  }

  section.addons {
    display: flex;
    padding: 30px;
    padding-right: 15px;
  }

  section.addons img {
    filter: inherit;
    margin-right: 16px;
    
}
.info-addons p {
  font-size: 13px;
  color: #646569;
  font-weight: 400;
  line-height: 20px;
}
.info-addons span {
  font-size: 12px;
  color: #646569;
  font-weight: 400;
  line-height: 20px;
  display: flex;
}
.info-addons p:nth-child(2) {
  font-weight: bold;
  color: #03A1DF;
  font-size: 17px;
}
  .ir-store {
    font-weight: bold !important;
    margin-left: 3px;
    font-size: 12px !important;
}

.consultando-desafios {
  position: absolute;
  background: white;
  padding: 26px;
  padding-bottom: 90px;
}

.etiqueta {
  color: #FFFFFF;
  padding: 2px 10px 2px 11px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 400;
  margin-left: 9px;
  height: 18px;
  line-height: 1.3;
}

section.contenedor-factores {
  position: relative;
  border-top: none;
}

.factor-error input{
  background: #97979726;
  border-color: #979797 !important;
}

.accordion__button {
  background-color: transparent;
}
.accordion__button:hover {
  background-color: transparent;
}

.accordion__button:before {
  float: right;
  color: #00A1DF;
  transform: rotate(45deg);
}

.accordion__button[aria-expanded='true']::before, .accordion__button[aria-selected='true']::before {
  transform: rotate(225deg) !important;
}
.accordion__panel {
  padding-top: 0 !important;
}

@media (max-width: 426px){
  .row-detalle p {
    font-size: 13px;
  }
  .row-detalle span {
    font-size: 13px;
  }
  .row-detalle span {
    width: 160px;
  }
  .subtitulo-formulario{
    font-size: 13px;
  }
  .body-webpay-coopeuch .Button--primary{
    font-size: 13px;
  }
  ._2p8qe._1r-Fe{
    font-size: 13px;
  }
  .accordion__heading {
    font-size: 14px;
  }
}

@media (max-width: 376px){
  .row-detalle p {
    font-size: 11px;
  }
  .row-detalle span {
    font-size: 11px;
  }
  .row-detalle span {
    width: 133px;
  }
  .subtitulo-formulario{
    font-size: 12px;
    padding-right: 0px !important;
    font-weight: 500 !important;
  }
  .body-webpay-coopeuch .Button--primary{
    font-size: 11px;
  }
  ._2p8qe._1r-Fe{
    font-size: 11px;
  }
  .accordion__heading {
    font-size: 14px;
  }
}



@media (max-width: 321px){
  .row-detalle p {
    font-size: 11px;
  }
  .row-detalle span {
    font-size: 11px;
  }
  .row-detalle span {
    width: 133px;
  }
  .subtitulo-formulario{
    font-size: 12px;
    padding-right: 0px !important;
    font-weight: 500 !important;
  }
  .body-webpay-coopeuch .Button--primary{
    font-size: 11px;
  }
  ._2p8qe._1r-Fe{
    font-size: 11px;
  }
  .accordion__heading {
    font-size: 14px;
  }
}
`;

export default Contenedor;
